import { oauth2Service } from '@/services/api'
import { getToken, getRefreshToken, saveToken, saveRefreshToken, destroyToken, destroyRefreshToken, getAppKey, saveAppKey } from '@/services/jwt'

const initialStates = {
    status: 'NONE',
    accessToken: getToken() || '',
    refreshToken: getRefreshToken() || '',
    appKey: getAppKey() || null
}

const mutations = {
    updateToken(state, token) {
        saveToken(token.access)
        state.accessToken = token.access

        saveRefreshToken(token.refresh)
        state.refreshToken = token.refresh

        saveAppKey(token.app)
        state.appKey = token.app

        state.status = 'SUCCESS'
    },
    updateStatus(state, status) {
        state.status = status
    },
    removeToken() {
        destroyToken()
        destroyRefreshToken()
    }
}

const getters = {
    status: state => state.status,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    isTokenExpired: state => () => {
        if (state.accessToken) {
            // Token is present
            if (state.accessToken.split('.').length === 3) {
                // Token with a valid JWT format XXX.YYY.ZZZ
                try {
                    // Could be a valid JWT or an access token with the same format
                    const base64Url = state.accessToken.split('.')[1];
                    const base64 = base64Url.replace('-', '+').replace('_', '/');
                    const exp = JSON.parse(window.atob(base64)).exp
                    if (typeof exp === 'number') {
                        // JWT with an optonal expiration claims
                        return Math.round(new Date().getTime() / 1000) >= exp
                    }
                } catch (e) {
                    return false // Pass: Non-JWT token that looks like JWT
                }
            }
            return false // Pass: All other tokens
        }

        return true
    }
}

const actions = {
    authenticate({commit}, data) {
        return new Promise((resolve, reject) => {
            oauth2Service.callback(data).then(response => {
                const { access_token, refresh_token } = response.data

                commit('updateToken', {
                    access: access_token,
                    refresh: refresh_token,
                    app: data.state
                })

                resolve()
            }).catch (err => {
                reject(err)
            })
        })
    },

    login() {
        const data = {
            baseUrl: process.env.VUE_APP_BASE_OAUTH2,
            service_id: getAppKey(),
            client: {
                id: process.env.VUE_APP_OAUTH2_ACCOUNT_ID,
                redirect: process.env.VUE_APP_OAUTH2_REDIRECT
            }
        }

        window.location.href = `${data.baseUrl}/oauth/authorize?client_id=${data.client.id}&redirect_uri=${data.client.redirect}&response_type=code&state=${data.service_id}`

        return false
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}